import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { createMemoryHistory } from 'history';
import { Router } from '../router';

const getRouterProps = memoryRouterProps => {
  const {
    isStatic = false,
    isGlobal = true,
    basePath,
    routes,
    resourceData,
    resourceContext
  } = memoryRouterProps;
  let routerProps = {
    basePath,
    routes,
    isStatic,
    isGlobal
  };

  if (resourceData) {
    routerProps = _extends(_extends({}, routerProps), {}, {
      resourceData
    });
  }

  if (resourceContext) {
    routerProps = _extends(_extends({}, routerProps), {}, {
      resourceContext
    });
  }

  return routerProps;
};
/**
 * Ensures the router store uses memory history.
 *
 */


export const MemoryRouter = props => {
  const {
    location,
    children
  } = props;
  const config = {};

  if (location) {
    config.initialEntries = [location];
  }

  const history = createMemoryHistory(config);
  const routerProps = getRouterProps(props);
  return (
    /*#__PURE__*/
    // @ts-ignore suppress history will be overwritten warning
    React.createElement(Router, _extends({
      history: history
    }, routerProps), children)
  );
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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